import { googlePlaceIds } from 'src/atoms/compare'

import { venueIdPlaceMatchHint, internalGooglePlaceId, googleSearchString, googleSearchResult } from 'src/atoms/search'

import { GooglePlace } from 'src/utils/google-places'
import { useRecoilTransaction_UNSTABLE } from 'recoil'
import { MapLocation } from 'src/components/map-layers/better-venues-layer/types'

const emptyVenuesArray: any = []
export const useSetGooglePlace = (venues: Pick<MapLocation, 'placeId' | 'venueId'>[] = emptyVenuesArray) => {
  const setPlace = useRecoilTransaction_UNSTABLE(
    (txn) => (placeId: GooglePlace['place_id'] | undefined) => {
      const place = venues.find((x) => x.placeId === placeId)
      txn.set(venueIdPlaceMatchHint, place?.venueId)
      const currentGooglePlaceId = txn.get(internalGooglePlaceId)
      if (currentGooglePlaceId !== placeId) {
        txn.set(googlePlaceIds, [])
      }
      txn.set(internalGooglePlaceId, placeId)

      const results = txn.get(googleSearchResult)
      const resultsIds = results ? results.map((x) => x.place_id) : []
      if (placeId && resultsIds.length && !resultsIds.includes(placeId)) {
        txn.set(googleSearchString, undefined)
        txn.set(googleSearchResult, undefined)
      }
    },
    [venues]
  )
  return setPlace
}
